module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Building-38aac988b0a38175972dd57363278a35.svg";